export const DEFAULT_TRACE_SAMPLE_RATE = 0.01;
export const PRODUCTS_TRACE_SAMPLE_RATE = 0.1;

const productsTransactionNames = new Set(["/products", "GET /products"]);

export const tracesSampler = ({ name, inheritOrSampleWith }) =>
	inheritOrSampleWith(
		productsTransactionNames.has(name)
			? PRODUCTS_TRACE_SAMPLE_RATE
			: DEFAULT_TRACE_SAMPLE_RATE,
	);

// Connect spans are dropped here and not with the pg instrumentation's
// `ignoreConnectSpans`, which also drops the context binding of pooled
// queries and attaches them to another request once the pool is full.
export const ignoredSpans = [/^pg(-pool)?\.connect$/];
